import { Button, Grid, TextField } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import HeaderPage from "../../components/HeaderPage/Index";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import {
  clearData,
  getData,
  storeData,
  getAllStorage,
  callChoice,
} from "../../utils/GlobalHelper";
import InfoIcon from "@mui/icons-material/Info";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import DialogError from "../../components/CustomDialog/DialogCustoms";
import Configs from "../../constants/Configs";
import GlobalApi from "../../utils/GlobalApi";
import Loading from "../../components/loading/loading";
import qs from "qs";
import Securities from "../../components/CustomDialog/Securities";
import { isEmpty } from "lodash";

const header = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
  },
};
const SuitResult = (props) => {
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const [lang, setLang] = useState(getData("lang"));
  const [translations, setTranslations] = useState("");
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSecurities, setIsSecurities] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง"
  );
  const suitability = getData("suitability");
  const idc = getData("idc");
  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const career = getData("f3_career");
  const suit = getData("suit_json");
  let snapIdCard = getData("uploadImage");

  const checkJumpPage = async () => {
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      !productChoice ||
      isEmpty(suit) ||
      isEmpty(suitability)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const handleNext = async () => {
    storeData("stamp_page", "JOBS");
    var last_stamp = JSON.stringify(await getAllStorage("JOBS"));
    const saveData = [
      {
        name: "comeback",
        url: `${Configs.baseAPIURL03}/form/comeback/manp`,
        postData: {
          head_token: head_token,
          last_stamp: last_stamp,
          stamp_page: "JOBS",
        },
      },
    ];
    setIsLoading(true);
    try {
      await GlobalApi.post(
        saveData[0].url,
        qs.stringify(saveData[0].postData),
        header
      )
        .then((res) => {
          setIsLoading(false);
          if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
            let mss =
              res.data.Data[0].MsgDesc !== ""
                ? res.data.Data[0].MsgDesc
                : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
            let title = "เกิดข้อผิดพลาด";
            setIsLoading(false);
            setIsModalError(true);
            setModalErrorTitle(title);
            setModalErrorDes(mss);
          } else {
            props.history.push("/status");
          }
        })
        .catch((er) => {
          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
            getData("api_error")?.message +
            ")";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
        });
    } catch (error) {
      setIsLoading(false);
      setIsModalError(true);
    }
  };
  const handleReevaluate = (e) => {
    if (e) {
      clearData("suit_json");
      clearData("chooce");
      clearData("suitability");
      props.history.push("/suit");
    }
  };
  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) {
        setJumpPage(true);
      } else {
        const translation = getData("Translations");
        if (!isEmpty(translation)) {
          setTranslations(translation);
        } else {
          props.history.push("/");
        }
      }
    });
  }, []);
  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.suit?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? props.history.push("/suit_15") : "")}
          />
          <Loading status={isLoading} />
          <DialogCustoms
            open={isModal}
            isModel={setIsModal}
            switchType={handleReevaluate}
            title={translations?.[lang]?.suit?.suit_alert?.title}
            massage={translations?.[lang]?.suit?.suit_alert?.massage}
            btnPrimary={translations?.[lang]?.suit?.suit_alert?.btnPrimary}
            btnSecondary={translations?.[lang]?.suit?.suit_alert?.btnSecondary}
          />
          <DialogError
            open={isModalError}
            isModel={setIsModalError}
            title={modalErrorTitle}
            massage={modalErrorDes}
            btnPrimary={"ตกลง"}
          />
          <Securities open={isSecurities} btn="ปิด" isModel={setIsSecurities} />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.suit}
                        clickBack={(e) => props.history.push("/suit_15")}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                      
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >  <HeaderRight
                          title={
                            translations?.[lang]?.suit?.suit_result?.header
                          }
                        />
                          <ScrollBarComponent
                            content={
                              <Grid>
                                <Grid className="font-20 text-primary font-DBHeavent font-weight-bold">
                                  {
                                    translations?.[lang]?.suit?.suit_result
                                      ?.score
                                  }
                                </Grid>
                                <Grid className="pt-2 pb-2">
                                  <Grid className="bg-score-3">
                                    <Grid className="bg-score-2">
                                      <Grid className="bg-score">
                                        <Grid
                                          className="bg-score-text"
                                          container
                                          direction="row"
                                          justifyContent="center"
                                          alignItems="center"
                                        >
                                          <Grid item xs={12}>
                                            <Grid
                                              style={{
                                                marginTop: "-12px",
                                                marginBottom: "-20px",
                                              }}
                                            >
                                              {suitability.totol_score}
                                            </Grid>

                                            <Grid className="font-24">
                                              {
                                                translations?.[lang]?.suit
                                                  ?.suit_result?.score_text
                                              }
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid>
                                  <Grid className="pb-4">
                                    <Grid className="input-form">
                                      <TextField
                                        className="font-20"
                                        id="standard-basic"
                                        label="ชื่อ - นามสกุล"
                                        variant="standard"
                                        value={`${idc?.nameTH}${
                                          idc?.middlenameTH
                                            ? " " + idc?.middlenameTH + " "
                                            : " "
                                        }${idc?.lastnameTH}`}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                        fullWidth
                                      />
                                    </Grid>
                                    <Grid className="input-form">
                                      <TextField
                                        className="font-20"
                                        id="standard-basic"
                                        label="ระดับความเสี่ยงที่รับได้"
                                        variant="standard"
                                        value={suitability?.type}
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                        fullWidth
                                      />
                                    </Grid>
                                  </Grid>
                                  <Grid>
                                    <Grid className="pt-2 pb-2" container>
                                      <Grid className="font-20 text-primary font-DBHeavent font-weight-bold">
                                        {
                                          translations?.[lang]?.suit
                                            ?.suit_result?.recommend
                                        }
                                      </Grid>
                                      <Grid>
                                        <InfoIcon
                                          onClick={() => setIsSecurities(true)}
                                          sx={{
                                            paddingLeft: "10px",
                                            paddingTop: "3px",
                                            color: "var(--lemon)",
                                            fontSize: "20px",
                                            cursor: "pointer",
                                          }}
                                        />
                                      </Grid>
                                    </Grid>
                                    <Grid className="suit-recommend">
                                      {suitability?.recommend?.map((re, i) => (
                                        <Grid
                                          key={i}
                                          container
                                          className="font-20 text-primary font-DBHeavent pt-2 pb-2"
                                        >
                                          <Grid item xs={1}>
                                            <li />
                                          </Grid>
                                          <Grid item xs>
                                            {re.label}
                                          </Grid>
                                        </Grid>
                                      ))}
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            }
                          />     <Grid
                          sx={{
                            backgroundColor: "transparent",
                            height: "20%",
                          }}
                        >
                          <Grid className="pb-3">
                            <Button
                              onClick={() => setIsModal(true)}
                              className="btn-secondary-cancel font-20 font-weight-bold"
                            >
                              {translations?.[lang]?.suit?.suit_result.re_btn}
                            </Button>
                          </Grid>
                          <Grid>
                            <ButtonRight
                              text={translations?.[lang]?.suit?.suit_result.btn}
                              onNextPage={handleNext}
                            />
                          </Grid>
                        </Grid>
                        </Grid>
                   
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};
export default memo(SuitResult);
